import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  reload: {
    description: 'Reload button label for the Returns grid',
    defaultMessage: 'Reload',
    id: 'fegVlA',
  },
  export: {
    description: 'Export button label for the Returns grid',
    defaultMessage: 'Export',
    id: 'poDTE+',
  },
  allStores: {
    description: 'Label shown in the Returns grid header when viewing returns across all stores',
    defaultMessage: 'Returns',
    id: 'RmRDmD',
  },
  unknownStore: {
    description: 'Fallback label shown in the Returns grid header when the store name cannot be found',
    defaultMessage: 'Unknown Store',
    id: 'Eqg3eO',
  },
  fetchReturnsError: {
    description: 'Error notification shown when the returns grid fails to load data',
    defaultMessage: 'Failed to load returns. Please try again.',
    id: '84vgT2',
  },
});

export const viewMessages = defineMessages({
  pendingApproval: {
    description: 'View Name to filter returns grid by Pending Approval Status',
    defaultMessage: 'Pending Approval',
    id: 'dULkvh',
  },
  pendingPayment: {
    description: 'View Name to filter returns grid by Pending Payment Status',
    defaultMessage: 'Pending Payment',
    id: 's2IhQZ',
  },
  needsAttention: {
    description: 'View Name to filter returns grid by Needs Attention Status',
    defaultMessage: 'Needs Attention',
    id: 'rQ6Y+5',
  },
  completed: {
    description: 'View Name to filter returns grid by Completed Status',
    defaultMessage: 'Completed',
    id: 'XLhKVi',
  },
  locked: {
    description: 'View Name to filter returns grid by Locked Status',
    defaultMessage: 'Locked',
    id: '+kgFpp',
  },
  awaitingShipment: {
    description: 'View Name to filter returns grid by Awaiting Shipment Status',
    defaultMessage: 'Awaiting Shipment',
    id: '0oJ2M4',
  },
  processing: {
    description: 'View Name to filter returns grid by Processing Status',
    defaultMessage: 'Processing',
    id: 'I94DI8',
  },
  flagged: {
    description: 'View Name to filter returns grid by Flagged Status',
    defaultMessage: 'Flagged',
    id: 'U3JutR',
  },
});

export const columnMessages = defineMessages({
  requestNumber: {
    description: 'Column header for a Request or RMA number in the Returns grid',
    defaultMessage: 'Request #',
    id: 'MaTrts',
  },
  orderNumber: {
    description: 'Column header for the Order Number in the Returns grid',
    defaultMessage: 'Order #',
    id: 'p5pBDC',
  },
  createDate: {
    description: 'Column header for the Create Date for a return in the Returns grid',
    defaultMessage: 'Create Date',
    id: 'm/Ay1E',
  },
  customerName: {
    description: 'Column header for a Customer Name in the Returns grid',
    defaultMessage: 'Customer Name',
    id: 'XwTSC9',
  },
  customerEmail: {
    description: 'Column header for a Customer Email in the Returns grid',
    defaultMessage: 'Customer Email',
    id: 'lXUTdr',
  },
  action: {
    description: 'Column header for an Action in the Returns grid',
    defaultMessage: 'Action',
    id: 'uYraJB',
  },
  status: {
    description: 'Column header for the Return Status in the Returns grid',
    defaultMessage: 'Return Status',
    id: 'sIMcmK',
  },
  lockedReason: {
    description: 'Column header for the Locked Reason in the Returns grid',
    defaultMessage: 'Locked Reason',
    id: 'FEjOJl',
  },
  amount: {
    description: 'Column header for the Amount in the Returns grid',
    defaultMessage: 'Amount',
    id: 'vsqVLg',
  },
  store: {
    description: 'Column header for the Store in the Returns grid',
    defaultMessage: 'Store',
    id: 'd3BM+P',
  },
  trackingNumber: {
    description: 'Column header for the Tracking Number in the Returns grid',
    defaultMessage: 'Tracking #',
    id: '6CUbtB',
  },
  carrierService: {
    description: 'Column header for the Carrier and Service in the Returns grid',
    defaultMessage: 'Service',
    id: 'wGPIvE',
  },
  source: {
    description: 'Column header for the Source in the Returns grid',
    defaultMessage: 'Source',
    id: 'M0CdVo',
  },
});
